import { ArrowIcon } from "components/common/Icons/ArrowIcon";
import { useToggle } from "client/hooks/utils/useToggle";
import { MobileNavMenuItem } from "components/modules/Navigation/Navbar/Account/Mobile/MobileNavMenuItem";
import { useAccountNavigation } from "components/modules/Navigation/Navbar/Account/useAccountNavigation";
import { UserIcon } from "lucide-react";
import { useEffect, useState } from "react";
import useAuth from "@/components/modules/Auth/useAuth";
import { translateFunc } from "@/utils/translateFunc";
import { useMobileNavigationMenu } from "../../../MobileNavigation/MobileNavigation";

export const UserSettingsMenu = () => {
    const { navLinks } = useAccountNavigation();
    const { isOpen, toggle } = useToggle();
    const { getUserEmail } = useAuth();
    const { closeModal } = useMobileNavigationMenu();
    const [userEmail, setUserEmail] = useState<string | null>(null);

    useEffect(() => {
        const email = getUserEmail();
        setUserEmail(email);
    }, [getUserEmail]);

    return (
        <li className="w-full py-3 flex flex-col gap-2 px-5 text-black dark:text-white border-b-slate-200 border-b dark:border-b-darkSurface-300">
            <div className="flex gap-2 items-center" onClick={toggle}>
                <UserIcon
                    className="bg-gray-200 dark:bg-white/20 p-1 rounded-full aspect-square min-w-[30px]"
                    size={30}
                />
                {userEmail ? (
                    <span className="overflow-hidden truncate">{userEmail}</span>
                ) : (
                    <span className="capitalize">Account</span>
                )}
                {isOpen ? (
                    <span className="rotate-180">
                        <ArrowIcon className="min-w-[10px]" width={10} />
                    </span>
                ) : (
                    <ArrowIcon className="min-w-[10px]" width={10} />
                )}
            </div>
            {isOpen && (
                <div>
                    {navLinks.map((link) => (
                        <MobileNavMenuItem
                            key={link.titleKey}
                            title={translateFunc(link.titleKey)}
                            onClick={() => {
                                closeModal();
                                link.onClick();
                            }}
                        />
                    ))}
                </div>
            )}
        </li>
    );
};
